import secureStorage from './secureStorage';

const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
const LANGUAGE_KEY = 'LANGUAGE';
// Refresh tokens on web are managed internally by oidc-client-ts (sessionStorage).
// These stubs keep the storageService interface consistent with the native implementation.
const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN';
const LOGIN_HINT_KEY = 'LOGIN_HINT';
const FORCE_REAUTH_KEY = 'FORCE_REAUTH';
const AGENCY_CODE_KEY = 'AGENCY_CODE';

export const storageService = {
  async getAuthToken(): Promise<string | null> {
    return secureStorage.getItem(AUTH_TOKEN_KEY);
  },

  async setAuthToken(token: string): Promise<void> {
    await secureStorage.setItem(AUTH_TOKEN_KEY, token);
  },

  async removeAuthToken(): Promise<void> {
    await secureStorage.removeItem(AUTH_TOKEN_KEY);
  },

  async getRefreshToken(): Promise<string | null> {
    return secureStorage.getItem(REFRESH_TOKEN_KEY);
  },

  async setRefreshToken(token: string): Promise<void> {
    await secureStorage.setItem(REFRESH_TOKEN_KEY, token);
  },

  async removeRefreshToken(): Promise<void> {
    await secureStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  async setLanguage(language: string): Promise<void> {
    await secureStorage.setItem(LANGUAGE_KEY, language);
  },

  async getLanguage(): Promise<string | null> {
    return secureStorage.getItem(LANGUAGE_KEY);
  },

  async setLoginHint(hint: string): Promise<void> {
    await secureStorage.setItem(LOGIN_HINT_KEY, hint);
  },

  async getLoginHint(): Promise<string | null> {
    return secureStorage.getItem(LOGIN_HINT_KEY);
  },

  async removeLoginHint(): Promise<void> {
    await secureStorage.removeItem(LOGIN_HINT_KEY);
  },

  async setForceReauth(): Promise<void> {
    await secureStorage.setItem(FORCE_REAUTH_KEY, 'true');
  },

  async getForceReauth(): Promise<boolean> {
    return (await secureStorage.getItem(FORCE_REAUTH_KEY)) === 'true';
  },

  async clearForceReauth(): Promise<void> {
    await secureStorage.removeItem(FORCE_REAUTH_KEY);
  },

  async setAgencyCode(code: string): Promise<void> {
    await secureStorage.setItem(AGENCY_CODE_KEY, code);
  },

  async getAgencyCode(): Promise<string | null> {
    return secureStorage.getItem(AGENCY_CODE_KEY);
  },

  async removeAgencyCode(): Promise<void> {
    await secureStorage.removeItem(AGENCY_CODE_KEY);
  },
};